<template>
  <el-container v-loading="loading" element-loading-text="Ładowanie danych...">
      <el-main>
      <el-card class="box-card">
        <a href="/">
          <img class="logo" src="/img/logo.png" alt="Kreator" />
        </a>
      </el-card>
      <el-menu default-active="templates" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item><a href="/">Strona główna</a></el-menu-item>
        <el-menu-item><a href="/editor">Dodaj nowy szablon</a></el-menu-item>
        <el-menu-item index="templates" @click="showTemplates">Szablony</el-menu-item>
        <el-menu-item index="projects" @click="showProjects">Projekty</el-menu-item>
        <el-menu-item><a href="/login">Wyloguj</a></el-menu-item>
      </el-menu>
      <el-table
      :data="show == 'templates' ? filteredTemplates : filteredProjects"
      stripe
      style="width: 100%">
      <el-table-column v-for="item in show == 'templates' ? templatesHeader : projectsHeader" :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width">
      </el-table-column>
      <el-table-column
        fixed="right"
        align="right"
        label="Akcje"
        width="300">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            :test="scope"
            placeholder="Wpisz, aby wyszukać" />
        </template>
        <template slot-scope="scope">
          <el-button v-if="scope.row.hash" @click="toggleStatus(scope.row)" type="text" size="small">
            <i class="el-icon-lock"></i>
            {{ scope.row.status == '2' ? 'Odblokuj' : 'Zablokuj' }}
          </el-button>
          <el-button @click="edit(scope.row.hash || scope.row.code)" type="text" size="small">
            <i :class="show == 'templates' ? 'el-icon-edit' : 'el-icon-view'"></i>
            {{ show == 'templates' ? 'edytuj' : 'podgląd' }}
          </el-button>
          <el-button @click="confirmRemoveTemplate(scope.row)" type="text" size="small">
            <i class="el-icon-delete"></i>
            usuń
          </el-button>
        </template>
      </el-table-column>
        <template slot="empty">
          Nie znaleziono projektów
        </template>
      </el-table>
    </el-main>

    <el-dialog title="Czy usunąć szablon?" :visible.sync="removeDialogVisible" width="20%" :close-on-click-modal="false">
      <span>
        Czy na pewno chcesz usunąć ten szablon? Tej akcji nie będzie można cofnąć!
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="removeDialogVisible = false">Anuluj</el-button>
        <el-button type="primary" @click="remove">Tak</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'Manage',
    data() {
        return {
            loading: true,
            error: false,
            search: '',
            removeDialogVisible: false,
            elementToRemove: null,
            templates: [],
            projects: [],
            show: 'templates',
            projectsHeader: [
              {
                prop: "id",
                label: "ID",
                width: null
              },
              {
                prop: "hash",
                label: "Hash",
                width: null
              },
              {
                prop: "name",
                label: "Nazwa",
                width: null
              },
              {
                prop: "email",
                label: "E-mail",
                width: null
              },
              {
                prop: "note",
                label: "Uwagi",
                width: null
              },
              {
                prop: "status",
                label: "Status",
                width: null
              },
              {
                prop: "source",
                label: "Źródło",
                width: null
              },
              {
                prop: "orderId",
                label: "Nr zamówienia",
                width: null
              }
            ],
            templatesHeader: [
              {
                prop: "id",
                label: "ID",
                width: "100"
              },
              {
                prop: "code",
                label: "Kod",
                width: null
              },
              {
                prop: "name",
                label: "Nazwa",
                width: null
              },
              {
                prop: "photo",
                label: "Zdjęcie",
                width: null
              }
            ],
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
        }),
        filteredTemplates() {
          return Object.values(this.templates.filter((data) => {
            return  !this.search ||
                    data.name.toLowerCase().includes(this.search.toLowerCase()) ||
                    data.code.toLowerCase().includes(this.search.toLowerCase())
          }))
        },
        filteredProjects() {
          return Object.values(this.projects.filter((data) => {
            return  !this.search ||
                    data.name.toLowerCase().includes(this.search.toLowerCase()) ||
                    data.hash.toLowerCase().includes(this.search.toLowerCase()) ||
                    data.email.toLowerCase().includes(this.search.toLowerCase())
          }))
        }
    },
    created() {
        this.getTemplates()
          .then((response) => {
            this.loading = false
            this.templates = response.data
          })
          .catch(() => {
              this.error = true
              this.loading = false
          })
        console.log('created get all templates');
    },
    methods: {
        ...mapActions('creator', {
            getTemplates: 'getTemplates',
            getProjects: 'getProjects',
            deleteTemplate: 'deleteTemplate',
            deleteProject: 'deleteProject',
            setProjectStatus: 'setProjectStatus',
        }),
        handleSelect(key, keyPath) {
          console.log(key, keyPath);
        },
        edit(templateId) {
          window.location.href = `/editor/${templateId}`
        },
        showProjects() {
          this.show = 'projects';
          this.search = '';

          if (this.projects.length) {
            return 
          }

          this.loading = true

          this.getProjects()
            .then((response) => {
              this.loading = false
              this.projects = response.data
            })
            .catch(() => {
                this.error = true
                this.loading = false
            })
          console.log('created get all projects');
        },
        showTemplates() {
          this.show = 'templates';
          this.search = '';
        },
        confirmRemoveTemplate(template) {
          this.removeDialogVisible = true
          this.elementToRemove = template
        },
        remove() {
          if (this.elementToRemove == null) {
            return
          }

          const elementId = this.elementToRemove.id;

          (this.show == 'templates' ? this.deleteTemplate(elementId) : this.deleteProject(elementId))
            .then(() => {

              this.removeElement(elementId);

              this.elementToRemove = null;
              this.removeDialogVisible = false;

              this.$notify({
                title: 'OK!',
                message: 'Element został usunięty',
                type: 'success',
                position: 'bottom-right'
              });
            })
            .catch(() => {
              this.removeDialogVisible = false
              this.$notify.error({
                title: 'Ups!',
                message: 'Wystąpił błąd podczas usuwania elementu',
                position: 'bottom-right'
              });
            })
        },
        removeElement(elementId) {
          const index = this[this.show].findIndex((template) => template.id == elementId);
          this[this.show].splice(index, 1);
        },
        toggleStatus(project) {
          console.log(project);
          this.setProjectStatus({
            hash: project.hash,
            status: project.status == 1 ? 2 : 1
          })
          .then((data) => {
            console.log('set status success', data);
              if (data.success) {
                this.$notify({
                  title: 'OK!',
                  message: 'Projekt został zablokowany',
                  type: 'success',
                  position: 'bottom-right'
                });

                project.status = data.status
              }
            })
            .catch(() => {
              this.$notify.error({
                title: 'Ups!',
                message: 'Wystąpił błąd podczas blokowania projektu',
                position: 'bottom-right'
              });
            })
        }
    }
  }
</script>

<style lang="less" scoped>
  body {
    font-family: 'Raleway', sans-serif;
  }
  .el-main.main {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    p {
      max-width: 500px;
      margin: 15px auto 30px;
      color: rgb(146, 146, 146);
    }
  }
  .box-card {
    text-align: center;
  }
  .el-card__body {
    text-align: center;
  }
  .logo {
    width: auto;
    height: 100px;
    margin: 0 auto;
  }
</style>